// Значения breakpoints вынесены в константы, чтобы по ним можно было
// вычислить максимальный slidesPerView и заранее понять, хватит ли слайдов для loop.
const brandsBreakpoints = {
  0: {
    slidesPerView: 1,
  },
  576: {
    slidesPerView: 3,
  },
  768: {
    slidesPerView: 4,
  },
  992: {
    slidesPerView: 6,
  },
  1200: {
    slidesPerView: 7,
  },
  1400: {
    slidesPerView: 8,
  },
};

const articlesBreakpoints = {
  0: {
    slidesPerView: 1,
  },
  576: {
    slidesPerView: 2,
  },
  768: {
    slidesPerView: 2,
  },
  992: {
    slidesPerView: 3,
  },
  1200: {
    slidesPerView: 4,
  },
  1400: {
    slidesPerView: 5,
  },
};

const maxSlidesPerView = function (breakpoints) {
  let max = 0;

  Object.keys(breakpoints).forEach(function (key) {
    const value = breakpoints[key].slidesPerView;
    const count = value === "auto" ? 1 : Number(value) || 1;

    if (count > max) {
      max = count;
    }
  });

  return max;
};

// loop включаем только при достаточном числе слайдов. Считаем по максимуму
// breakpoints, а не по текущему viewport: иначе после resize на широком экране
// Swiper снова предупредит о нехватке слайдов.
const shouldLoop = function (element, breakpoints) {
  return element.querySelectorAll(".swiper-slide").length >= maxSlidesPerView(breakpoints) + 1;
};

document.querySelectorAll(".swiper.brands").forEach(function (element) {
  new Swiper(element, {
    slidesPerView: "auto", // Автоматически подстраивает количество
    spaceBetween: 0,
    loop: shouldLoop(element, brandsBreakpoints),
    autoplay: {
      delay: 0,
      disableOnInteraction: false,
      pauseOnMouseEnter: true,
    },
    speed: 2000,
    freeMode: true,
    breakpoints: brandsBreakpoints,
  });
});

document.querySelectorAll(".swiper.articles").forEach(function (element) {
  new Swiper(element, {
    slidesPerView: "auto", // Автоматически подстраивает количество
    spaceBetween: 12,
    loop: shouldLoop(element, articlesBreakpoints),
    //   autoplay: false,
    speed: 400,
    freeMode: true,
    navigation: {
      prevEl: ".swiper-controls>*:first-child",
      nextEl: ".swiper-controls>*:last-child",
    },
    breakpoints: articlesBreakpoints,
  });
});
